import { render, staticRenderFns } from "./LottieTest.vue?vue&type=template&id=012f241c&scoped=true&"
import script from "./LottieTest.vue?vue&type=script&lang=js&"
export * from "./LottieTest.vue?vue&type=script&lang=js&"
import style0 from "./LottieTest.vue?vue&type=style&index=0&id=012f241c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012f241c",
  null
  
)

export default component.exports